export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  invalidPassword: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  userIdRequired: "User ID is required",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateRequired: "Start Date is required.",
  endDateRequired: "End Date is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  sportsTypeRequired: "Sports Type is required.",
  teamTypeRequired: "Team Type is required.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction:"Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  unableSPProcess: "System unable to process your request.",
  connection: "Connection Error",

  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isSingleDecimal: "{fname} accept only numbers with up to 1 decimal place.",
  isInteger: "{fname} accept only integers.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  isBetween: "{fname} must be between {min} and {max}.",
  isSSFormat: "Invalid Super Senior account id format.",
  isReserved: "Reserved account id.",
  isExisted: "Account id existed.",
  onlySmallCapsAlphaNum: "Only lowercase characters and numbers from a to z and 0 to 9 allowed",
  noJavaScriptInjection: "{fname} contains invalid or potentially harmful characters.",

  system_error: "System unable to process your request.",
  invalid_password: "Invalid Username or Password.",
  block: "Your account has been blocked.",
  invalid_security_code: "Invalid security code.",

  source_account_id_required: "Account ID is required.",
  target_account_id_required: "Target account ID is required.",
  permission_denied: "No permission allowed.",
  account_id_required: "Account ID is required.",
  sub_login_id_required: "Login ID is required.",
  account_not_exists: "Account does not exists.",
  profile_not_exists: "Profile does not exists.",
  account_inactive: "Inactive account.",
  not_blocked_account: "Valid account.",
  password_required: "Password is required.",
  parent_id_required: "Parent ID is required.",
  parent_not_exists:"Parent ID does not exists.",
  invalid_account_type: "Invalid account type.",
  account_exists: "Account is already exists.",
  login_id_required: "Login ID is required.",
  new_login_id_required: "New login ID is required.",
  login_id_not_exists: "Login ID does not exists.",
  invalid_authority_role: "Invalid role.",
  profile_inactive: "Invalid profile.",
  secondary_account_exists: "Secondary account is already exists.",
  new_login_id_exists: "New login ID is already exists.",
  new_password_required: "New password is required.",
  security_tag_required: "Security tag is required.",
  security_code_required: "Security code is required.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  start_date_gt_end_date: "Start date is greater than end date.",
  member_id_required: "Member ID is required.",
  currency_code_required: "Currency code is required.",
  commission_setting_not_exists: "Commission setting does not exists.",
  incomplete_account_line: "Incomplete account line.",
  invalid_hdp_package: "Invalid HDP packages.",
  search_id_required: "Search ID is required.",
  profile_id_required: "Profile ID is required.",
  login_not_exists: "Login does not exists.",
  no_changes: "There is no changes detected.",
  start_date_require: "Start date is required.",
  league_id_required: "League ID is required.",
  sport_type_required: "Sport Type is reuired.",
  match_id_required: "Match ID is required.",
  target_login_id_required: "Target login ID is required.",
  parent_account_not_exists: "Parent account does not exists.",
  parent_account_inactive: "Inactive parent account.",
  parent_profile_not_exists: "Parent profile does not exists.",
  parent_profile_inactive: "Inactive parent profile.",
  target_login_id_not_exists: "Target login ID does not exists.",
  incorrect_parent: "Invalid parent ID.",
  invalid_session: "Invalid session request.",
  session_expired: "Session expired.",
  settle_amount_required: "Settle amount is required.",
  invalid_settle_amount: "Invalid settle amount.",
  settle_amount_gt_yesterday_balance: "Settle amount is greater than yesterday balance.",
  invalid_account_status: "Invalid account status.",
  bet_limit_packages_required: "Bet limit packages are required.",
  bet_limit_exists: "Bet limit is already exists.",
  member_bet_limit_package_gt_one: "Member bet limit packages is more than one.",
  parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  account_commission_required: "Account commission is required.",
  commission_setting_exists: "Commission setting already exists.",
  parent_comm_not_exists: "Parent commission setting does not exits.",
  exceeded_parent_comm: "Exceeded parent commission setting.",
  others_commission_required: "Others commission setting is required.",
  exceeded_parent_1x2: "Exceeded parent 1x2 commission setting.",
  exceeded_parent_other: "Exceeded parent other commission setting.",
  hdp_commission_required: "HDP commission setting is required.",
  exceeded_parent_hdp_a: "Exceeded parent HPD(A) commission setting.",
  exceeded_parent_hdp_b: "Exceeded parent HPD(B) commission setting.",
  exceeded_parent_hdp_c: "Exceeded parent HPD(C) commission setting.",
  exceeded_parent_hdp_d: "Exceeded parent HPD(D) commission setting.",
  exceeded_parent_hdp_e: "Exceeded parent HPD(E) commission setting.",
  exceeded_parent_hdp_f: "Exceeded parent HPD(F) commission setting.",
  exceeded_parent_hdp_g: "Exceeded parent HPD(G) commission setting.",
  exceeded_parent_hdp_h: "Exceeded parent HPD(H) commission setting.",
  exceeded_parent_hdp_i: "Exceeded parent HPD(I) commission setting.",
  exceeded_parent_hdp_j: "Exceeded parent HPD(J) commission setting.",
  LIVECASINO_upline_pt_required: "[Livecasino] Upline PT setting is required.",
  LIVECASINO_pt_setting_exists: "[Livecasino] PT setting is required.",
  LIVECASINO_parent_pt_not_exists: "[Livecasino] Parent PT setting does not exists.",
  LIVECASINO_parent_min_not_meet: "[Livecasino] Does not match with parent minimum PT.",
  LIVECASINO_exceeded_parent_pt: "[Livecasino] Exceeded parent PT setting.",
  LIVECASINO_account_pt_required: "[Livecasino] Account PT setting is required.",
  LIVECASINO_upline_remaining_required: "[Livecasino] Upline remaining PT setting is required.",
  LIVECASINO_account_min_required: "[Livecasino] Account minimum PT setting is required.",
  LIVECASINO_upline_remaining_gt_account_pt: "[Livecasino] Upline remaining PT setting is greater than account PT setting.",
  LIVECASINO_account_min_gt_p: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  SLOTS_upline_pt_required: "[Livecasino] Upline PT setting is required.",
  SLOTS_pt_setting_exists: "[Livecasino] PT setting is required.",
  SLOTS_parent_pt_not_exists: "[Livecasino] Parent PT setting does not exists.",
  SLOTS_parent_min_not_meet: "[Livecasino] Does not match with parent minimum PT.",
  SLOTS_exceeded_parent_pt: "[Livecasino] Exceeded parent PT setting.",
  SLOTS_account_pt_required: "[Livecasino] Account PT setting is required.",
  SLOTS_upline_remaining_required: "[Livecasino] Upline remaining PT setting is required.",
  SLOTS_account_min_required: "[Livecasino] Account minimum PT setting is required.",
  SLOTS_upline_remaining_gt_account_pt: "[Livecasino] Upline remaining PT setting is greater than account PT setting.",
  SLOTS_account_min_gt_pt: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  bet_type_required: "Bet type is required",
  schedule_1_to_7_required: "Settlement schedule is required",
  schedule_exists: "Settlement schedule does not exists.",
  parent_schedule_not_exists: "Parent settlement schedule does not exists.",
  schedule_1_not_available: "Settlement on Monday is not available.",
  schedule_2_not_available: "Settlement on Tuesday is not available.",
  schedule_3_not_available: "Settlement on Wednesday is not available.",
  schedule_4_not_available: "Settlement on Thursday is not available.",
  schedule_5_not_available: "Settlement on Friday is not available.",
  schedule_6_not_available: "Settlement on Saturday is not available.",
  schedule_7_not_available: "Settlement on Sunday is not available.",
  credit_limit_required: "Credit limit is required.",
  member_credit_limit_required: "Member credit limit is required.",
  wallet_exists: "Account is already exists.",
  member_credit_limit_gt_credit_limit: "Member credit limit is greater than credit limit.",
  parent_wallet_not_exists: "Account does not exists.",
  account_credit_limit_gt_parent: "Account credit limit is greater than parent credit limit.",
  member_credit_limit_gt_parent: "Member credit limit is greater than parent credit limit",
  exceeded_credit_limit: "Exceeded account credit limit.",
  soccer_min_bet_required: "Minimum bet is required.",
  soccer_max_bet_required: "Maximum bet is required.",
  soccer_max_per_match_required: "Maximum bet per match is required",
  soccer_bet_limit_exists: "Bet limit is already exists.",
  soccer_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  soccer_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  soccer_account_max_bet_gt_parent: "Account max bet is greater than parent",
  soccer_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  basketball_min_bet_required: "Minimum bet is required.",
  basketball_max_bet_required: "Maximum bet is required.",
  basketball_max_per_match_required: "Maximum bet per match is required",
  basketball_bet_limit_exists: "Bet limit is already exists.",
  basketball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  basketball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  basketball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  tennis_min_bet_required: "Minimum bet is required.",
  tennis_max_bet_required: "Maximum bet is required.",
  tennis_max_per_match_required: "Maximum bet per match is required",
  tennis_bet_limit_exists: "Bet limit is already exists.",
  tennis_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  tennis_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  tennis_account_max_bet_gt_parent: "Account max bet is greater than parent",
  tennis_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  baseball_min_bet_required: "Minimum bet is required.",
  baseball_max_bet_required: "Maximum bet is required.",
  baseball_max_per_match_required: "Maximum bet per match is required",
  baseball_bet_limit_exists: "Bet limit is already exists.",
  baseball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  baseball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  baseball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  baseball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  parlay_min_bet_required: "Minimum bet is required.",
  parlay_max_bet_required: "Maximum bet is required.",
  parlay_max_per_match_required: "Maximum bet per match is required",
  parlay_bet_limit_exists: "Bet limit is already exists.",
  parlay_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  parlay_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  parlay_account_max_bet_gt_parent: "Account max bet is greater than parent",
  parlay_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  esports_min_bet_required: "Minimum bet is required.",
  esports_max_bet_required: "Maximum bet is required.",
  esports_max_per_match_required: "Maximum bet per match is required",
  esports_bet_limit_exists: "Bet limit is already exists.",
  esports_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  esports_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  esports_account_max_bet_gt_parent: "Account max bet is greater than parent",
  esports_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  others_min_bet_required: "Minimum bet is required.",
  others_max_bet_required: "Maximum bet is required.",
  others_max_per_match_required: "Maximum bet per match is required",
  others_bet_limit_exists: "Bet limit is already exists.",
  others_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  others_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  others_account_max_bet_gt_parent: "Account max bet is greater than parent",
  others_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  used_credit_gt_credit_limit: "Used credit limit is greater than credit limit.",
  bet_limit_setting_not_exists: "Bet limit setting does not exists.",
  parent_bet_limit_setting_not_exists: "Parent bet limit setting does not exists.",
  package_not_exists_in_parent: "Parent bet limit package setting does not exists",
  soccer_bet_limit_setting_not_exists: "Soccer bet limit setting does not exixts.",
  soccer_update_interval_violated: "Update interval violated.",
  basketball_bet_limit_setting_not_exists: "Basketball bet limit setting does not exixts.",
  basketball_update_interval_violated: "Update interval violated.",
  tennis_bet_limit_setting_not_exists:"Tennis bet limit setting does not exixts.",
  tennis_update_interval_violated: "Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Baseball bet limit setting does not exixts.",
  baseball_update_interval_violated: "Update interval violated.",
  parlay_bet_limit_setting_not_exists:"Parlay bet limit setting does not exixts.",
  parlay_update_interval_violated: "Update interval violated.",
  esports_bet_limit_setting_not_exists:"Esports bet limit setting does not exixts.",
  esports_update_interval_violated: "Update interval violated.",
  others_bet_limit_setting_not_exists:"Others bet limit setting does not exixts.",
  others_update_interval_violated: "Update interval violated.",
  soccer_parent_bet_limit_setting_not_exists: "Soccer parent bet limit setting does not exixts.",
  soccer_min_bet_lt_parent: "Soccer account min bet is lower than parent.",
  soccer_max_bet_gt_parent: "Soccer account max bet is greater than parent.",
  soccer_max_per_match_gt_parent: "Soccer account max per match is greater than parent.",
  basketball_parent_bet_limit_setting_not_exists: "Basketball parent bet limit setting does not exixts.",
  basketball_min_bet_lt_parent: "Basketball account min bet is lower than parent.",
  basketball_max_bet_gt_parent: "Basketball account max bet is greater than parent.",
  basketball_max_per_match_gt_parent: "Basketball account max per match is greater than parent.",
  tennis_parent_bet_limit_setting_not_exists: "Tennis parent bet limit setting does not exixts.",
  tennis_min_bet_lt_parent: "Tennis account min bet is lower than parent.",
  tennis_max_bet_gt_parent: "Tennis account max bet is greater than parent.",
  tennis_max_per_match_gt_parent: "Tennis account max per match is greater than parent.",
  baseball_parent_bet_limit_setting_not_exists: "Baseball parent bet limit setting does not exixts.",
  baseball_min_bet_lt_parent: "Baseball account min bet is lower than parent.",
  baseball_max_bet_gt_parent: "Baseball account max bet is greater than parent.",
  baseball_max_per_match_gt_parent: "Baseball account max per match is greater than parent.",
  parlay_parent_bet_limit_setting_not_exists: "Parlay parent bet limit setting does not exixts.",
  parlay_min_bet_lt_parent: "Parlay account min bet is lower than parent.",
  parlay_max_bet_gt_parent: "Parlay account max bet is greater than parent.",
  parlay_max_per_match_gt_parent: "Parlay account max per match is greater than parent.",
  esports_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  esports_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  esports_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  esports_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  others_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  others_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  others_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  others_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  update_interval_violated: "Update interval violated.",
  exceeded_parent_others: "Exceeded parent others commission setting.",
  exceeded_parent_hdp: "Exceeded parent HDP bet limit setting.",
  soccer_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  soccer_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  basketball_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  basketball_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  tennis_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  tennis_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  baseball_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  baseball_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  parlay_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  parlay_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  esports_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  esports_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",
  others_min_bet_gt_max_bet: "Min bet must be lower or equal to Max bet.",
  others_max_bet_gt_max_per_match: "Max bet must be lower or equal to Max Per Match.",

  valid: "{fname} contains atleast One Uppercase, One Lowercase and One Number.(Eg: Abcd1234)",
  notSame: "New password can not be same with Old password."
};
